module.exports = __webpack_public_path__ + "img/page-not-found-animate.c16b3b14.svg";